import { render, staticRenderFns } from "./SynthesisOfAlumBalancedEquation.vue?vue&type=template&id=f4545c74&"
import script from "./SynthesisOfAlumBalancedEquation.vue?vue&type=script&lang=ts&"
export * from "./SynthesisOfAlumBalancedEquation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
